import { useLocation, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { List, Sun, Moon, ArrowUUpLeft, Buildings } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";
import { useOrg } from "@/context/OrgContext";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { PROMO_NAV } from "../nav";

export function PromotionTopBar({ theme, onToggleTheme, onOpenMenu }) {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { currentOrg } = useOrg();
  const location = useLocation();

  const active = PROMO_NAV.find((n) => (n.end ? location.pathname === n.to : location.pathname.startsWith(n.to) && n.to !== "/promotions"))
    || PROMO_NAV[0];
  const initials = (user?.name || "U").slice(0, 2).toUpperCase();

  return (
    <header
      className="promo-glass sticky top-0 z-40 flex h-16 items-center gap-3 border-b border-border px-4 md:px-8"
      data-testid="promo-topbar"
    >
      <button
        onClick={onOpenMenu}
        className="rounded-md p-1.5 text-muted-foreground hover:bg-accent md:hidden"
        data-testid="promo-menu-btn"
      >
        <List size={20} />
      </button>

      <nav className="flex items-center gap-2 text-sm" aria-label="breadcrumb">
        <span className="text-muted-foreground">Promotion Center</span>
        <span className="text-muted-foreground/50">/</span>
        <span className="font-medium">{t(active.labelKey)}</span>
      </nav>

      <div className="ml-auto flex items-center gap-1.5">
        <span
          className="hidden items-center gap-1.5 rounded-full border border-border px-2.5 py-1 text-xs text-muted-foreground sm:flex"
          data-testid="promo-org"
        >
          <Buildings size={13} />
          {currentOrg?.name || "—"}
        </span>

        <Link
          to="/dashboard"
          className="flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
          data-testid="promo-back-to-app"
        >
          <ArrowUUpLeft size={14} />
          <span className="hidden sm:inline">{t("promo.backToApp")}</span>
        </Link>

        <button
          onClick={onToggleTheme}
          className="rounded-md p-2 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground"
          data-testid="promo-theme-toggle"
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <Sun size={16} weight="bold" /> : <Moon size={16} weight="bold" />}
        </button>

        <Avatar className={cn("h-8 w-8 rounded-md")} data-testid="promo-avatar">
          <AvatarImage src={user?.picture} />
          <AvatarFallback className="rounded-md bg-primary text-xs text-primary-foreground">{initials}</AvatarFallback>
        </Avatar>
      </div>
    </header>
  );
}
